import { PropsWithChildren } from 'react';
import { useParams } from 'react-router-dom';

import { useSso } from '@newfold/huapi-js';
import { SsoParams } from '@newfold/huapi-js/src/index.schemas';

import useAccount from '~/hooks/useAccount';
import useHostingInfo from '~/hooks/useHostingInfo';

import SSOComponent from '../index';
import { SSO_HOOK_OPTIONS, useDisabledState } from '../utils/helpers';
import { BaseSsoProps } from '../utils/types';

interface HostingSSOProps extends BaseSsoProps {
  hostingId?: string | number;
}
const HostingSSO = ({
  children = undefined,
  hostingId = undefined,
  disabled = undefined,
  id = undefined,
  queryParams = {},
  ...props
}: PropsWithChildren<HostingSSOProps>) => {
  const { siteId } = useParams();
  const { id: accountHostingId } = useAccount();
  const accountId = hostingId || accountHostingId;

  const { isDisabled: hostingDisabled } = useHostingInfo({
    hostingId,
    options: {
      enabled: !!hostingId && disabled === undefined,
    },
  });

  const isDisabled = useDisabledState(disabled, hostingDisabled);

  const sso = useSso(
    accountId || hostingId,
    queryParams as SsoParams,
    SSO_HOOK_OPTIONS,
  );

  return (
    <SSOComponent
      sso={sso}
      isDisabled={isDisabled}
      siteId={siteId || id}
      hostingId={hostingId}
      queryParams={queryParams}
      {...props}
    >
      {children}
    </SSOComponent>
  );
};

export default HostingSSO;
